import React from 'react';

export const RelatedPersonIcon = ({ className }) => {
	return (
		<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15.5 7.5C16.875 7.5 18 8.625 18 10C18 11.375 16.875 12.5 15.5 12.5C14.125 12.5 13 11.375 13 10C13 8.625 14.125 7.5 15.5 7.5ZM15.5 20C18.875 20 22.75 21.6125 23 22.5H8C8.2875 21.6 12.1375 20 15.5 20ZM15.5 5C12.7375 5 10.5 7.2375 10.5 10C10.5 12.7625 12.7375 15 15.5 15C18.2625 15 20.5 12.7625 20.5 10C20.5 7.2375 18.2625 5 15.5 5ZM15.5 17.5C12.1625 17.5 5.5 19.175 5.5 22.5V25H25.5V22.5C25.5 19.175 18.8375 17.5 15.5 17.5Z" fill="#5F5F5F" />
		</svg>
	);
};
